import {
  RemoveShoppingCartOutlined,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { CircularProgress, Fab, Tooltip } from "@mui/material";
import * as React from "react";
import { XArticleContext } from "../../../context/XArticleProvider";
import { useCart } from "../../../hooks/useCart";
import { ICartItem } from "../../../utils/constants/dynamic/article";

const AddShoppingCartBtn: React.FC = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const { cart, setCart } = useCart();

  const article = React.useContext(XArticleContext);

  const isActived = !!cart.carts.find((e) => e.id === article.id);

  const updateCart = async () => {
    setLoading(true);
    try {
      setCart((old) => {
        const carts: ICartItem[] = isActived
          ? old.carts.filter((e) => e.id !== article.id)
          : [...old.carts, { ...article, qty: 1 }];

        return { ...old, carts };
      });
    } catch (error) {
      console.error("ERROR/ ADDING TO CART BTN =>", error);
    }
    setLoading(false);
  };

  const content = (
    <Fab
      className={isActived ? "isActived" : undefined}
      size="small"
      onClick={updateCart}
      disabled={loading}
    >
      {loading && <CircularProgress style={{ width: 30, height: 30 }} />}
      {!loading &&
        (!isActived ? (
          <ShoppingCartOutlined />
        ) : (
          <RemoveShoppingCartOutlined />
        ))}
    </Fab>
  );

  if (loading) return content;

  return (
    <Tooltip
      title={isActived ? "Retirer du Panier" : "Ajouter au Panier"}
      placement="left"
    >
      {content}
    </Tooltip>
  );
};

export default AddShoppingCartBtn;
